<template lang="pug">
</template>

<script>
export default {
  name: 'FiltersModal'
}
</script>

<style lang="scss" scoped>
</style>
